exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.print-btn[data-v-31616276] {\n  width: 210px;\n  height: 36px;\n  border-radius: 4px;\n  background-color: #000000;\n  border: solid 0.5px #e5e5e5;\n  color:white;\n}\n.disabled[data-v-31616276] {\n  width: 210px;\n  height: 36px;\n  border-radius: 4px;\n  background-color: #0000009c;\n  border: solid 0.5px #e5e5e5;\n  color:white;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-31616276","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/report/ReportZ.vue
// module id = 507
// module chunks = 1